var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.title)?_c('span',{staticClass:"countdown-timer"},[_vm._v(_vm._s(_vm.$t(_vm.title, { time: _vm.remainingTime })))]):_c('span',[_vm._v(_vm._s(_vm.remainingTime))])}
var staticRenderFns = []

export { render, staticRenderFns }